import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { growlErrors } from '../utils/NotificationUtil';
import { withGrowl } from './GrowlNotifications';
import { growlShape } from './prop-types';

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(err) {
    const { growl } = this.props;
    growlErrors(growl, err.err);
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <h1>Oops...!!!</h1>;
    }
    return children;
  }
}

Boundary.propTypes = {
  growl: growlShape.isRequired,
  children: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withGrowl(Boundary);
